import React, { useState } from 'react';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AddLedgers from './AddLedgers';
import useGetGlLedgersList from '../../../../hooks/Finance/useGetGlLedgersList';
import UpdateLedgers from './UpdateLedgers';
import { type LedgersModels } from '../../../../store/Finance/Ledgers/LedgersModels';
import Loading from '../../../../components/Shared/Loader/Loading';
import NtxTable from '../../../../components/DataTable/NtxTable';

const Index = () => {
  const [Show, setShow] = useState(false);

  const { t, i18n } = useTranslation();
  const { LedgersList, loading, error } = useGetGlLedgersList();

  const [dataById, setDataById] = useState<LedgersModels>(); // for sent as props to Update component PeriodsModels

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('Currency'), key: 'cur' },

    { title: t(''), key: 'action', className: 'text-end' },
  ];

  const tableData = LedgersList?.map((item) => {
    let rowClass;

    return {
      Name: i18n.language === 'ar' ? item.name2 : item.name,
      cur: item.currencyCode,

      action: (
        <>
          <button
            type="button"
            className="btn btn-sm btn-outline-theme"
            data-bs-toggle="modal"
            data-bs-target="#modalUpdateLedgers"
            onClick={() => setDataById(item)}>
            <i className="far fa-lg fa-fw fa-edit me-1"></i>
            {t('Button.Edit')}
          </button>
        </>
      ),

      rowClass, // استخدم rowClass هنا
    };
  });

  //____________________________
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome',
    },
    {
      name: 'GeneralLedger',
      link: null,
    },
  ];

  return (
    <div>
      <div className="d-flex align-items-center">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName="GeneralLedger" />

        <div className="ms-auto">
          <Link
            to=""
            className="btn me-1 btn-theme"
            data-bs-toggle="modal"
            data-bs-target="#modalAddLedgers"
            onClick={() => setShow(true)}>
            <i className="fa fa-plus-circle fa-fw me-1"></i>
            {t('AddGeneralLedger')}
          </Link>
        </div>
      </div>
      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=""
              tableClass="table text-nowrap table-hover "
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddGeneralLedger')} id="modalAddLedgers" size="lg">
        {Show && <AddLedgers />}
      </ModalComponent>

      <ModalComponent title={t('EditGeneralLedger')} id="modalUpdateLedgers" size="lg">
        {dataById && <UpdateLedgers DataById={dataById} />}
      </ModalComponent>
    </div>
  );
};

export default Index;
